import type { ApiHelper, ApiResponseWithData, BaseRequest } from '..';
import { ApiHelperWithData, splitParams } from '..';

// 등록 요청 타입
export interface MgHstCreateParams {
  empId: string;
  empNm: string;
  mgHst: string;
  rcmmCd: string;
}

export interface MgHstDeleteParams {
  empId: string;
  mgHstOdnm: string;
}
// 검색 조건 타입
export interface MgHstSearchParams {
  empNm: string;
  projectName?: string;
  rcmmCd?: string;
  pageNumber: number;
  rowsPerPage: number;
}
// 조회 결과 row 타입
export interface MgHstSearchItem {
  empId: string;
  empNm: string;
  mgHstOdnm: string;
  mgHst: string;
  rcmmCd: string;
  RegrId: string;
  RegDttm: string;
}

export interface MgHstSearchResponse {
  list?: MgHstSearchItem[];
  totalElements?: number;
  totalPages?: number;
}

export class MngStaffApi {
  private withData: ApiHelperWithData;

  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  create = (
    params: MgHstCreateParams & BaseRequest,
  ): Promise<ApiResponseWithData<{ result: number }>> => {
    const url = '/apis/mng-staff/create';
    return this.withData.postJson(url, ...splitParams(params));
  };

  search = (
    params: MgHstSearchParams & BaseRequest,
  ): Promise<ApiResponseWithData<MgHstSearchResponse>> => {
    const url = '/apis/mng-staff/search';
    return this.withData.postJson(url, ...splitParams(params));
  };

  delete = (
    params: MgHstDeleteParams & BaseRequest,
  ): Promise<ApiResponseWithData<{ result: number }>> => {
    const url = '/apis/mng-staff/delete';
    return this.withData.postJson(url, ...splitParams(params));
  };
}
